import apiRemovalRequests from '@/api/removal-requests'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getRemovalRequestsStart: '[removal-requests] Get removal-requests start',
  getRemovalRequestsSuccess: '[removal-requests] Get removal-requests success',
  getRemovalRequestsFailure: '[removal-requests] Get removal-requests failure',
}

export const actionTypes = {
  getRemovalRequests: '[removal-requests] Get removal-requests list',
}

const mutations = {
  [mutationTypes.getRemovalRequestsStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getRemovalRequestsSuccess](state, payload) {
    const list = payload.list || payload.data || []
    state.data = payload.isAdd ? [...state.data, ...list] : list

    state.total = payload.total
    state.lastPage = payload.lastPage || payload.last_page
    state.isLoading = false
  },

  [mutationTypes.getRemovalRequestsFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getRemovalRequests](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)
    context.commit(mutationTypes.getRemovalRequestsStart)
    return new Promise((resolve) => {
      apiRemovalRequests
        .getRemovalRequestsList(params)
        .then((response) => {
          context.commit(mutationTypes.getRemovalRequestsSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getRemovalRequestsFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
